import { motion } from "framer-motion"

export const BlobCircleBackground = () => {
  return (
    <>
      <motion.div
        style={{ willChange: "transform" }}
        className="absolute top-[20%] md:right-[10%] right-[-10%] w-[200px] h-[200px] rounded-full bg-gradient-to-br from-[#3BA1FF] to-[#62EB60] blur-3xl md:opacity-50 opacity-20"
        animate={{
          x: ["0%", "-40%", "20%", "0%"],
          y: ["0%", "30%", "-20%", "0%"],
        }}
        transition={{ duration: 25, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        style={{ willChange: "transform" }}
        className="absolute bottom-[20%] md:left-[-10%] left-[-50%] w-[300px] h-[300px] rounded-full bg-gradient-to-tr from-[#0A91FF] via-[#908EFF] to-[#FF7AD2] blur-2xl md:opacity-50 opacity-20"
        animate={{
          x: ["0%", "40%", "-10px", "0%"],
          y: ["0%", "-20%", "40%", "0%"],
        }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 3,
        }}
      />
    </>
  )
}
